import React from "react";

const NotFound = () => {
  return (
    <>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">404</div>
        </div>
      </div>
      <section className="flat-spacing-25">
        <div className="container">
          <div className="tf-main-area-page text-center p-5">
            <h4>Page Not Found</h4>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
